export const hasAivReadAccess = ({
  aiVisibilityEnabled,
  isSuperadmin,
  hasReadPermission,
}) => Boolean(aiVisibilityEnabled && (isSuperadmin || hasReadPermission));

export const hasAivEditAccess = ({
  aiVisibilityEnabled,
  isMasquerading,
  hasEditPermission,
}) => Boolean(aiVisibilityEnabled && !isMasquerading && hasEditPermission);
